export default {"src":"/_next/static/media/icon-play-border-white.95373918.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};